import { Component, inject } from '@angular/core';
import { Menu } from '../../models/menu.model';
import { MENU } from '../../data/menu.data';
import { UiService } from '../../services/ui.service';

/**
 * Shell del tablero: panel lateral + barra superior, ambos de cristal y fijos.
 *
 * El ancho reservado al panel lo decide `UiService.sidebarMode()` y viaja al
 * SCSS por el atributo `data-sidebar` del shell, para que barra y contenido
 * lean el mismo estado y no dos medias queries que se contradicen.
 */
@Component({
  selector: 'app-dashboard-layout',
  templateUrl: './dashboard-layout.component.html',
  styleUrl: './dashboard-layout.component.scss',
  standalone: false,
})
export class DashboardLayoutComponent {

  public readonly uiService: UiService = inject(UiService);

  public menu: Array<Menu> = MENU;
}
